<template>
    <div>
        <div>
            <el-form label-position="right" label-width="120px">
                <el-form-item label="设备名">
                    <el-input v-model="filter.shopName" size="small"
                              type="textarea"
                              placeholder="设备名" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="设备价格">
                    <el-input v-model="filter.price" size="small"
                              type="textarea"
                              placeholder="设备价格" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="归还天数">
                    <el-input v-model="filter.returnDay" size="small"
                              type="textarea"
                              placeholder="归还天数" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="免租日">
                    <el-input v-model="filter.freeDay" size="small"
                              type="textarea"
                              placeholder="免租日" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="日租金">
                    <el-input v-model="filter.dailyRent" size="small"
                              type="textarea"
                              placeholder="日租金" style="width: 200px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreShopName()"
                       :loading="button_loading">保存
            </el-button>
        </div>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialogs_StoreShopName",
        data() {
            return {
                filter:{
                    shopName:'',
                    price:'',
                    status:'',
                    returnDay:'',
                    freeDay:'',
                    dailyRent:''
                },
                button_loading:false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleStoreShopName(){
                this.button_loading=true;
                this.$axios.post(store.state.server + '/createShopName', {
                        'shopName':this.filter.shopName,
                        'price':this.filter.price,
                        'returnDay':this.filter.returnDay,
                        'freeDay':this.filter.freeDay,
                        'dailyRent':this.filter.dailyRent,
                    }
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.button_loading=false;
                        if (Object.keys(this.$parentInfo.shopNames).length <10) {
                            this.$set(this.$parentInfo.shopNames, response.data.content.shopName.id, response.data.content.shopName)
                        }
                        this.$parentInfo.total++
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.loading=false;
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            }
        }
    }
</script>

<style scoped>

</style>